import { useUploadContextFactory } from '../upload-contexts/use-upload-context-factory';
import FileUpload from './file-upload-component';
import ColumnMapper from './column-mapper';
import DataValidationTable from './table-data-validator';
import ShowResults from './show-results';
import { STAGES } from './use-upload';

export const UploadComponent = ({ contextType }) => {
  const { stage } = useUploadContextFactory({ contextType });

  const renderStage = () => {
    switch (stage) {
      case STAGES.RESULTS:
        return <ShowResults contextType={contextType} />;
      case STAGES.VALIDATE:
        return <DataValidationTable contextType={contextType} />;
      case STAGES.MAP:
        return <ColumnMapper contextType={contextType} />;
      case STAGES.UPLOAD:
      default:
        return <FileUpload contextType={contextType} />;
    }
  };

  return <div className="pt-4 pb-4 overflow-scroll">{renderStage()}</div>;
};
